import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const response = await fetch('https://readdy.ai/api/form/d9sncjdlbrt1qcgaj6e0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，每周精选内容将发送到你的邮箱。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setStatus('error');
        setMessage(serverMsg.includes('spam') ? '订阅失败，请稍后再试。' : '订阅失败，请检查邮箱格式后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试。');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-secondary-950">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-500/20">
          <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-400"></i>
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
          订阅男子汉宝藏
        </h2>
        <p className="text-sm md:text-base text-secondary-400 mb-8 max-w-lg mx-auto">
          每周精选硬核好物推荐、深度评测和生活方式内容，直接送到你的邮箱。不废话，不扰民。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 bg-secondary-800 border border-secondary-700 rounded-lg text-sm text-background-50 placeholder:text-secondary-500 focus:outline-none focus:border-primary-500 transition-colors"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="antispam-field"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="whitespace-nowrap px-6 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 font-medium text-sm rounded-lg transition-colors"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
            {message}
          </p>
        )}
        <p className="mt-4 text-xs text-secondary-600">我们尊重你的隐私，绝不发送垃圾邮件。</p>
      </div>
    </section>
  );
}